import { render } from "./QuizDynamic.vue?vue&type=template&id=c3909772&scoped=true"
import script from "./QuizDynamic.vue?vue&type=script&lang=js"
export * from "./QuizDynamic.vue?vue&type=script&lang=js"

import "./QuizDynamic.vue?vue&type=style&index=0&id=c3909772&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3909772"]])

export default __exports__